export class BankDetails {
  public id: number;
  public bankName: string;
  public bankId: number;
  public routingNumber: number;
  public bankAcctNumber: string;
}
